import {createSlice, createSelector} from '@reduxjs/toolkit';
import {FormAgencyInit} from "./agencyModel";


// import {INIT} from './../constants/status';

const initialState = {
    agencies: [],
    provinceIsAgencies: [],
    agencyForm: FormAgencyInit,
    provinces:[],
};

const agencySlice = createSlice({
    name: 'agency',
    initialState,
    reducers: {
        setAgencies: (state, action) => {
            state.agencies = action.payload;
        },
        setProvinceIsAgencies: (state, action) => {
            state.provinceIsAgencies = action.payload
        },
        onAgencyFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.agencyForm[name] = value;
        },
        initAgencyForm: (state, action) => {
            state.agencyForm = action.payload;
        },
        setProvinces: (state, action) => {
            state.provinces = action.payload;
        },
    },
});

export const {actions} = agencySlice;
export const {
    setAgencies,
    setProvinceIsAgencies,
    onAgencyFormChange,
    initAgencyForm,
    setProvinces
} = actions;

// selectors

export const selAgencies = (state) => state.agency.agencies;
export const selProvinceIsAgencies = (state) => state.agency.provinceIsAgencies;
export const selAgencyForm = (state) => state.agency.agencyForm;
export const selProvinces = (state) => state.agency.provinces;

const reducer = {
    agency: agencySlice.reducer,
};
export default reducer;